export var ACTION_ACCOUNT;
(function (ACTION_ACCOUNT) {
    ACTION_ACCOUNT["ON_CHANGE"] = "ON_CHANGE";
    ACTION_ACCOUNT["ON_LOAD"] = "ON_LOAD";
    ACTION_ACCOUNT["ON_ENTER_PROFILE_DETAILS"] = "ON_ENTER_PROFILE_DETAILS";
    ACTION_ACCOUNT["ON_ENTER_PAYOUT_DETAILS"] = "ON_ENTER_PAYOUT_DETAILS";
    ACTION_ACCOUNT["ON_ENTER_ARN_DETAILS"] = "ON_ENTER_ARN_DETAILS";
    ACTION_ACCOUNT["ON_SAVE_PROFILE_DETAILS"] = "ON_SAVE_PROFILE_DETAILS";
    ACTION_ACCOUNT["ON_SAVE_PAYOUT_DETAILS"] = "ON_SAVE_PAYOUT_DETAILS";
    ACTION_ACCOUNT["ON_SELECT_PAN_TYPE"] = "ON_SELECT_PAN_TYPE";
    ACTION_ACCOUNT["ON_CHANGE_NAME"] = "ON_CHANGE_NAME";
    ACTION_ACCOUNT["ON_CHANGE_COMPANY_NAME"] = "ON_CHANGE_COMPANY_NAME";
    ACTION_ACCOUNT["ON_SELECT_DETAILS_FOR"] = "ON_SELECT_DETAILS_FOR";
    ACTION_ACCOUNT["ON_CLICK_PROFILE_EDIT"] = "ON_CLICK_PROFILE_EDIT";
    ACTION_ACCOUNT["ON_CLICK_PAYOUT_EDIT"] = "ON_CLICK_PAYOUT_EDIT";
    ACTION_ACCOUNT["OPEN_MENU"] = "OPEN_MENU";
    ACTION_ACCOUNT["ON_SET_NEW_PASSWORD"] = "ON_SET_NEW_PASSWORD";
    ACTION_ACCOUNT["ENTER_PASSWORD"] = "ENTER_PASSWORD";
    ACTION_ACCOUNT["GET_REENTERED_PASSWORD"] = "GET_REENTERED_PASSWORD";
    ACTION_ACCOUNT["SEND_PASSWORD"] = "SEND_PASSWORD";
    ACTION_ACCOUNT["TOGGLE_PASSWORD"] = "TOGGLE_PASSWORD";
})(ACTION_ACCOUNT || (ACTION_ACCOUNT = {}));
export var PAN_TYPE;
(function (PAN_TYPE) {
    PAN_TYPE["RESIDENT_INDIVIDUAL_SELF"] = "RESIDENT_INDIVIDUAL_SELF";
    PAN_TYPE["RESIDENT_INDIVIDUAL_OTHER"] = "RESIDENT_INDIVIDUAL_SELF";
    PAN_TYPE["LLP"] = "RESIDENT_INDIVIDUAL_SELF";
    PAN_TYPE["HUF"] = "HUF";
    PAN_TYPE["PRIVATE_LIMITED"] = "Private Limited";
    PAN_TYPE["INDIVIDUAL"] = "Individual";
    PAN_TYPE["SOLE_PROPRIETOR"] = "Sole Proprietor";
    PAN_TYPE["PARTNERSHIP"] = "PARTNERSHIP";
    PAN_TYPE["OPC"] = "OPC";
    PAN_TYPE["OTHER"] = "OTHER";
})(PAN_TYPE || (PAN_TYPE = {}));
export const PanType = ['RESIDENT_INDIVIDUAL_SELF', 'RESIDENT_INDIVIDUAL_SELF', 'LLP', 'HUF', 'PRIVATE_LIMITED', 'INDIVIDUAL', 'SOLE_PROPRIETOR', 'PARTNERSHIP', 'OPC', 'OTHER'];
